export { default as Login } from './Login';
export { default as ResetPassword } from './ResetPassword';
export { default as ResetPasswordView } from './ResetPasswordView';
export { default as ChangePassword } from './ChangePassword';
export { default as ChangePasswordView } from './ChangePasswordView';
export { default as LoginAdmin } from './LoginAdmin';



// WEBPACK FOOTER //
// ./src/features/login/index.js